import { useState } from 'react';
// configs
import { EX7959 } from 'config/flags';
// contexts
import { useModalYoutubeContext } from 'context';
// components
import { ExLoader } from '@commons/EXComponentsLibrary/ExLoader';
import { Modal } from 'rsuite';
// styles
import styles from './ModalYoutube.module.css';

const ModalYoutube = () => {
    const { openModalYoutube, setOpenModalYoutube } = useModalYoutubeContext();
    const [loading, setLoading] = useState<boolean>(true);

    const handleClose = () => {
        if (!localStorage.getItem('firstShowModalYoutube')) {
            localStorage.setItem('firstShowModalYoutube', 'true');
            window.dispatchEvent(new Event('firstShowModalYoutubeSet'));
        }
        setOpenModalYoutube(false);
    };

    return (
        <Modal size={'lg'} open={openModalYoutube} className={styles['wrapper']} backdrop>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                className={styles['close-icon']}
                onClick={handleClose}
            >
                <path
                    d="M20.0003 22.3337L11.8337 30.5003C11.5281 30.8059 11.1392 30.9587 10.667 30.9587C10.1948 30.9587 9.80588 30.8059 9.50033 30.5003C9.19477 30.1948 9.04199 29.8059 9.04199 29.3337C9.04199 28.8614 9.19477 28.4725 9.50033 28.167L17.667 20.0003L9.50033 11.8337C9.19477 11.5281 9.04199 11.1392 9.04199 10.667C9.04199 10.1948 9.19477 9.80588 9.50033 9.50033C9.80588 9.19477 10.1948 9.04199 10.667 9.04199C11.1392 9.04199 11.5281 9.19477 11.8337 9.50033L20.0003 17.667L28.167 9.50033C28.4725 9.19477 28.8614 9.04199 29.3337 9.04199C29.8059 9.04199 30.1948 9.19477 30.5003 9.50033C30.8059 9.80588 30.9587 10.1948 30.9587 10.667C30.9587 11.1392 30.8059 11.5281 30.5003 11.8337L22.3337 20.0003L30.5003 28.167C30.8059 28.4725 30.9587 28.8614 30.9587 29.3337C30.9587 29.8059 30.8059 30.1948 30.5003 30.5003C30.1948 30.8059 29.8059 30.9587 29.3337 30.9587C28.8614 30.9587 28.4725 30.8059 28.167 30.5003L20.0003 22.3337Z"
                    fill="white"
                />
            </svg>
            <Modal.Body className={styles['modalBody']}>
                <div className={styles['videoContainer']}>
                    {loading && (
                        <div className={styles['loader']}>
                            <ExLoader size="md" />
                        </div>
                    )}
                    <video
                        className={styles['video']}
                        src={`/assets/videos/${
                            EX7959 ? 'video-cargadecredencialesv5' : 'video-carga-de-credenciales'
                        }.mp4`}
                        autoPlay={true}
                        controls={true}
                        controlsList="nodownload"
                        onContextMenu={(e) => e?.preventDefault()}
                        playsInline
                        onCanPlay={() => setLoading(false)}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalYoutube;
